<template>
  <div class="help-center-post-share__component">
    <p class="help-center-post-share__label">
      {{ label }}
    </p>
    <div class="help-center-post-share__links">
      <a
        v-for="shareLink in shareLinks"
        :key="shareLink.icon"
        :href="shareLink.url"
        :title="shareLink.title"
        :class="shareLink.class"
        class="help-center-post-share__link"
        target="_blank"
        rel="noopener"
      >
        <i
          class="help-center-post-share__icon"
          :class="shareLink.icon"
        />
      </a>
    </div>
  </div>
</template>

<script setup>
/* global webpack */

import { computed } from 'vue'
import HELP_CENTER_TYPES from 'help-center/constants/types'

const props = defineProps({
  type: {
    type: String,
    required: true
  },
  post: {
    type: Object,
    required: true
  },
  fragment: String
})

const label = computed(() => {
  return `Share this ${postType.value}`
})

const postUrl = computed(() => {
  // all social networks ignore the fragment, so there's no point in adding it to the URL
  const url = new URL(props.post.url, webpack.apiServerHost)
  return url.toString()
})

const postType = computed(() => {
  if (props.type === HELP_CENTER_TYPES.UPDATES) {
    return 'update'
  } else {
    return 'article'
  }
})

const shareLinks = computed(() => {
  return [{
    url: `https://www.facebook.com/sharer/sharer.php?u=${postUrl.value}`,
    icon: 'fab fa-facebook-f',
    class: 'help-center-post-share__link--facebook',
    title: `Share ${postType.value} on Facebook`
  }, {
    url: `https://twitter.com/intent/tweet?url=${postUrl.value}`,
    icon: 'fab fa-x-twitter',
    class: 'help-center-post-share__link--xtwitter',
    title: `Share ${postType.value} on X`
  }, {
    url: `https://www.linkedin.com/shareArticle?mini=true&url=${postUrl.value}`,
    icon: 'fab fa-linkedin-in',
    class: 'help-center-post-share__link--linkedin',
    title: `Share ${postType.value} on Linkedin`
  }]
})
</script>

<style lang="scss">
@import 'help-center/mixins';

$socials: facebook, xtwitter, linkedin;

.help-center-post-share {
  &__component {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__label {
    @include help-center-font(12);
    text-transform: uppercase;
    font-weight: var(--help-center-bold);
    color: var(--help-center-muted);
  }

  &__links {
    display: flex;
    gap: 8px;
  }

  &__link {
    @include help-center-link;
    display: flex;

    @each $social in $socials {
      &--#{$social} {
        color: help-center-brand-color($social);
      }
    }
  }

  &__icon {
    @include help-center-icon(16);
  }
}
</style>
